import React, { useState, useEffect, memo } from "react";
import { connect } from "react-redux";
import InputWithMovingLabel from "jd-library/InputWithMovingLabel";
import { Regex } from "../../utills";
// import { scrollIntoView } from "../../../utills.js";
import style from "./Styles/general-details.scss";
import "./Styles/inventory-batches.scss";
import Form from 'jd-library/Form';
import Dropdown from 'jd-library/Dropdown';
import ToggleBtnGroup from 'jd-library/ToggleBtnGroup';
import FormDate from 'jd-library/FormDate';
import styles from '../add-edit-product/ProductExpiry/product-expiry.scss';
import Commission from './Commission';
import axios from "axios";
import useUpdateMRP from "../../common/UpdateMRP/UpdatePriceValue";
import useUploadPhotoProof from "../../common/UpdateMRP/UploadPhotoProof";

const SingleBatch = (props) => {
  const { item, index, errorObj,tabKey } = props;
  const key = index;
  const [formFields, setInventoryForm] = useState(() => ({ ...item, createdon: new Date(item.createdon) }));
  const [singleBatch, setToggleBatch] = useState(false);
  let uomJson = props.uomArr ? props.uomArr.uomJsonMap : {};
  let unitOfMeasurement = props.itemInfo.unitOfMeasurement,
    unitPerPiece = props.itemInfo.unitPerPiece;
  let uomType = props.itemInfo.uomType
    ? props.itemInfo.uomType
    : props.itemInfo.packagingType;
  let newQuantityRegex =
    uomType == "BOTH" || uomType == "LOOSE"
      ? /^\d{0,8}(\.\d{0,2})?$/
      : /^\d{0,8}$/;
      const currentIndex = { ...formFields };

  const scrollIntoViewHandle = (e) => {
    const currentTarget = e.currentTarget;
    if (props.deviceData && props.deviceData.isMobile) {
      //       e.currentTarget && scrollIntoView(currentTarget);
    }
  };
  const [expiryBy, toggleExpiryBy] = useState(props.item?.expiryBy?.value || 'manufacturing_date');
  console.log("single batch",props.index,expiryBy,props.item?.expiryBy)

  const [disable_mrp_edit, set_disable_mrp_edit] = useState(item.isTemplate);
  // const [is_initial_lode, set_is_initial_lode] = useState(false)
  // useEffect(() => {
  //   if (!is_initial_lode && formFields) {
  //     if (formFields["mrp"].value?.trim() != "") {
  //       set_disable_mrp_edit(true)
  //     }
  //     set_is_initial_lode(true)
  //   }

  // }, [formFields])

  const [CommentAndUploadVisibility, showCommentAndUpload] = useState(formFields.mrp_status === 'REJECTED' || formFields.mrp_status === 'IMAGES REQUIRED' || false)
  
  const { showMRPModal, getUpdateMRPModal, mrp: mrpValue } = useUpdateMRP(
    (value) => {
      let isMrpValidated = false
      handleChange(value, "mrp", false);
      formFields.mrp_list.forEach((e) => {
        if (Math.round(Number(e)) === Math.round(Number(value))) {
          isMrpValidated = true
        }

      })
      if (!isMrpValidated) {
        showCommentAndUpload(true);
        
        // handleChange(true, "mrp_validated", false);
        currentIndex["mrp_validated"] = true
        props.updateInventory({
          index: index,
          params: currentIndex,
        });
      }else{
        showCommentAndUpload(false);
        
        currentIndex["mrp_validated"] = false
        props.updateInventory({
          index: index,
          params: currentIndex,
        });
      }
    },
    formFields["mrp"].value?.trim(),
    props.itemInfo,
    false
  )


  const { getBothCommentAndUpload } = useUploadPhotoProof(CommentAndUploadVisibility, (...e) => {
    // console.log("UploadPhotoProof", e, props.itemInfo.mrp)
    const [mrpProofImages,productFrontImages, cur_batch]=e;
    const temp_errorObj = errorObj
    let data = { ...item };
    if (mrpProofImages?.length) {
      const upload_urls = mrpProofImages.map(uploads => uploads.url)
      // handleChange(upload_urls.join(","), "mrp_images", false);
      data['mrp_images'] = upload_urls.join(",")

      if (!upload_urls.length) {
        let arr = [...errorObj];
        arr[index] = {
          mrpError: ''
        }
        props.updateError(() => arr);
      } else {
        let arr = [...errorObj];
        arr[index] = {
          mrpError: ''
        }
        props.updateError(() => arr);;
      }
    } else {
      data['mrp_images'] = ''
    }

    if (productFrontImages?.length) {
      const upload_urls = productFrontImages.map(uploads => uploads.url)
      // handleChange(upload_urls.join(","), "mrp_front_img", false);
      data['mrp_front_img'] = upload_urls.join(",")

      if (!upload_urls.length) {
        let arr = [...errorObj];
        arr[index] = {
          productFrontProofError: ''
        }
        props.updateError(() => arr);
      } else {
        let arr = [...errorObj];
        arr[index] = {
          productFrontProofError: ''
        }
        props.updateError(() => arr);;
      }
    } else {
      data['mrp_front_img'] = ''
    }
    setInventoryForm(currentIndex);
    setTimeout(() => {
      props.updateInventory({
        index: index,
        params: data,
      });
    }, 30);
  }, undefined, [errorObj[index]?.mrpError,errorObj[index]?.productFrontProofError])
  const [commissionRate, setCommissionRate] = useState(item.commission_value);
  const [sellingPrice, setSellingPrice] = useState(null);


  const [loading, setLoading] = useState(false);

  let dateOptions = [{
    label: 'Days',
    key: 'days'
  }, {
    label: 'Months',
    key: 'months'
  }, {
    label: 'Years',
    key: 'years'
  }];

  const validate = (value, formattedDate, activeTab, from) => {
    const currentDate = new Date();
    if (value) {
      currentDate.setHours(value.getHours(), value.getMinutes(), value.getSeconds(), value.getMilliseconds())
      //Ignore time param while comparing two dates.
    }
    let dateTab = activeTab || expiryBy;
    let errorMsg = "";
    let warnMsg = '';
    if (dateTab == "expiry_date") {
        // props.updateItemDisplayInfo({formattedExpDate: formattedDate});
        if (value == "" || value == null) {
            errorMsg = "";
            currentIndex[dateTab].isWarning = false;
            currentIndex[dateTab].errorMessage = "";
        } else if (currentDate.getDate() == value.getDate() && currentDate.getMonth() == value.getMonth() && currentDate.getFullYear() == value.getFullYear() && (formattedDate && !formattedDate.includes("Y"))) {
            warnMsg = "Please note that the product will expire today";
            errorMsg = warnMsg;
            currentIndex[dateTab].isWarning = true;
            currentIndex[dateTab].errorMessage = warnMsg;
        }
        else if (value.getDate && isNaN(value.getDate()) && (formattedDate && !formattedDate.includes("Y"))) {
            errorMsg = "Please Enter Valid Date";
            currentIndex[dateTab].isWarning = false;
            currentIndex[dateTab].errorMessage = errorMsg;
        } else if(props.session.viaOmni){
          const todayGMT=new Date()
          const todayUTC= new Date(Date.UTC(todayGMT.getFullYear(),todayGMT.getMonth(),todayGMT.getDate()))
          if(value<todayUTC){
            errorMsg = "Entered past date for expire date";
            currentIndex[dateTab].isWarning = false;
            currentIndex[dateTab].errorMessage = errorMsg;
          }
        }

        // handleChange('validate', 'expiry_date', null, errorMsg, warnMsg);
    }
    if (dateTab == "manufacturing_date") {
        // props.updateItemDisplayInfo({formattedManufDate: formattedDate});
        if (value == "" || value == null) {
            errorMsg = "";
            currentIndex[dateTab].isWarning = false;
            currentIndex[dateTab].errorMessage = "";
        }
        else if (value.getDate && isNaN(value.getDate()) && (formattedDate && !formattedDate.includes("Y"))) {
            errorMsg = "Please Enter Valid Date";
            currentIndex[dateTab].isWarning = false;
            currentIndex[dateTab].errorMessage = errorMsg;
        }

        if(props.session.viaOmni){
          const todayGMT=new Date()
          const todayUTC= new Date(Date.UTC(todayGMT.getFullYear(),todayGMT.getMonth(),todayGMT.getDate()))
          if(value>todayUTC){
            errorMsg = "Entered future date for manufacture date";
            currentIndex[dateTab].isWarning = false;
            currentIndex[dateTab].errorMessage = errorMsg;
          }
        }
        props.updateInventory({
          index: index,
          params: currentIndex,
        });
        // handleChange('validate', 'manufacturing_date', null, errorMsg, warnMsg);
        if(props.item.best_before.value && (value == "" || !value)){
            validateBestBeforeDate({warnMsg: warnMsg, currentManufacturingDate: '', errorMsg: errorMsg});
        }
        else if(props.item.best_before.value)
        {
            validateBestBeforeDate({warnMsg: warnMsg, currentManufacturingDate: value});
        }
    }
  }
  const getDateObj = (dateString) => {
    let dateStr = typeof dateString === 'string' ? dateString : dateString.value;
    if(dateStr)
    {
        var dateParts = dateStr.split('/');
        // month is 0-based, that's why we need dataParts[1] - 1
        var dateObj = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
        if(isNaN(dateObj)) return ""
        return(dateObj);
      }
  }
  const validateBestBeforeDate = (params = {}) => {
    let { unit, warnMsg, currentManufacturingDate, errorMsg } = params;
    var bestBeforeInDays = Number(props.item.best_before.value);
    var currentDate = new Date();
    var warningMsg = warnMsg || '';
    var best_before_unit = unit || props.item.best_before_unit.value || 'months';
    if (best_before_unit == 'months') {
      bestBeforeInDays = bestBeforeInDays * 30;
    } else if (best_before_unit == 'years') {
      bestBeforeInDays = bestBeforeInDays * 365;
    }

    if (props.item.manufacturing_date.value || currentManufacturingDate) {
      var manufDateObj = getDateObj(props.item.manufacturing_date);
      if (currentManufacturingDate) {
        manufDateObj = currentManufacturingDate;
      }

      var expDateByBestBefore = new Date();
      expDateByBestBefore.setTime(manufDateObj.getTime() + bestBeforeInDays * 86400000);
      if (currentDate.getDate() == expDateByBestBefore.getDate() && currentDate.getMonth() == expDateByBestBefore.getMonth() && currentDate.getFullYear() == expDateByBestBefore.getFullYear()) {
        warningMsg = "Warning: Please note that the product will expire today.";
      }

      if (errorMsg) {
        warningMsg = '';
        // handleChange('manufacturing_date', null, errorMsg, '');
        currentIndex['manufacturing_date'].isWarning = false;
        currentIndex['manufacturing_date'].errorMessage = errorMsg;
      } else {
        // handleChange('manufacturing_date', null, warningMsg, warningMsg);
        currentIndex['manufacturing_date'].isWarning = warningMsg ? true : false;
        currentIndex['manufacturing_date'].errorMessage = warningMsg;
      }


    }
  }

  const getCommissionRate = async (sp, consignmentNo, productId) => {
    setLoading(true);
    axios.get(`/marketplace/static/php/web/b2bWebsite.php?action=commissionRate&productid=${productId}&selling_price=${sp}&lastbatch_consignment_no=${consignmentNo}`).then((data) => {
      setLoading(false);
      let commissionRate = data?.data?.Commission_Rate ? parseFloat(data.data.Commission_Rate).toFixed(2) : 0;

      setCommissionRate(commissionRate);
    });
    setSellingPrice(sp);
  }

  const handleChange = (value, key, ignoreRegex = true) => {
    if (props.session.isReadOnly) return;
    if (key=="expiryBy") {
      currentIndex[key].value = value;
      setInventoryForm(currentIndex);
      props.updateInventory({
        index: index,
        params: currentIndex,
      });
      return
    }


    if (
      !props.deviceData.isIPhone &&
      !Regex.priceRegex.test(value) &&
      !ignoreRegex
    ) {
      return;
    }
    if (!ignoreRegex && value == ".") {
      return;
    }
    currentIndex[key].value = value;
    currentIndex[key].errorMessage = "";
    currentIndex[key].isWarning = false;
    
    let mrp = currentIndex["mrp"] ? currentIndex["mrp"].value : null;
    
    if (key == "selling_price") {
      if (value && Number(value) && (!mrp || Number(value) > Number(mrp))) {
        // currentIndex[key].isWarning = true;
        currentIndex[key].errorMessage = "Higher than MRP";
      } else {        
        currentIndex[key].isWarning = false;
        currentIndex[key].errorMessage = "";
      }
    }
    if (key == "mrp" && currentIndex["selling_price"]) {
      if (Number(value) >= Number(currentIndex["selling_price"].value)) {
        currentIndex["selling_price"].isWarning = false;
        currentIndex["selling_price"].errorMessage = "";
      } else {
        // currentIndex['sellingPrice'].isWarning = true;
        currentIndex["selling_price"].errorMessage = "Higher than MRP";
      }
    }

    if(props.session.viaOmni){
      let formattedDate= (expiryBy == 'manufacturing_date'?props.item.manufacturing_date.value:props.item.expiry_date.value) || ""
      if(formattedDate.split("").length<3){
        validate("", formattedDate, expiryBy);
      }  else   {
        const [yyyy,mm,dd]=formattedDate.split("/").reverse()              
        validate(
          new Date(Date.UTC(yyyy,mm-1,dd)),
          formattedDate, expiryBy
        );
      }           
     
    }
    // if (key == "mrp" && currentIndex["selling_price"]) {
    //   if (Number(value) > Number(currentIndex["spPerPc"].value)) {
    //     currentIndex["selling_price"].isWarning = false;
    //     currentIndex["selling_price"].errorMessage = "";
    //   } else {
    //     currentIndex["selling_price"].isWarning = true;
    //     currentIndex["selling_price"].errorMessage = "Higher than MRP";
    //   }
    // }
    // console.log("key",key)
    // if(key=="mrp_validated" || key=="mrp_images"){
    //   currentIndex[key]=value
    //   alert("hi")
    // } else{
    //   currentIndex[key].value = value;
    // }
    setInventoryForm(currentIndex);
    props.updateInventory({
      index: index,
      params: currentIndex,
    });
  };

  const closeEditSlider = () => {
    setToggleBatch(false);
  };

  useEffect(() => {
    setInventoryForm({ ...item, createdon: new Date(item.createdon) });
  }, [item]);

  // let expiryBy = "manufacturing_date";
  // if (
  //   formFields.expiryDate &&
  //   formFields.expiryDate.value &&
  //   formFields.manufacturingDate &&
  //   !formFields.manufacturingDate.value
  // ) {
  //   expiryBy = "best_before";
  // }

  return (
    <>
      <div className="inventory-list-heading">
        <div className="list-heading">
          <span className="heading-label">Batch Creation Date: </span>
          {formFields.lastModifiedTimestamp
            ? new Intl.DateTimeFormat("en-GB", {
              month: "long",
              day: "2-digit",
              year: "numeric",
            }).format(new Date(formFields.lastModifiedTimestamp))
            : !isNaN(formFields.createdon.getTime())
              ? new Intl.DateTimeFormat(
                "en-GB", {
                month: "long",
                day: "2-digit",
                year: "2-digit",
              }).format(formFields.createdon)
              : ""}
        </div>
        {/* <div className="list-heading">
          <span className="heading-label">Batch No.: </span>{" "}
          {formFields.consignment_no.value}
        </div> */}
      </div>
      <div className="main-sec no-margin" >
        {
          <>
 {!props.isInventoryCompliance ?            
            <InputWithMovingLabel
              label={"Quantity"}
              key={formFields["inStock"]?.key || "tempdata"}
              errorMessage={formFields["inStock"]?.errorMessage || ""}
              warning={formFields["inStock"]?.isWarning || false}
              input={{
                value: formFields["inStock"].value,
                onFocus: (e) => {
                  scrollIntoViewHandle(e);
                },
                onChange: (e) => {
                  let value = e.currentTarget.value;
                  if (!Number.isInteger(Number(value)) && uomType == "PACKED") {
                    let value = Number(value);
                    if (isNaN(value) || (!isNaN(value) && value > 99999999)) {
                      return;
                    }
                  } else if (
                    !props.deviceData.isIPhone &&
                    !newQuantityRegex.test(value)
                  ) {
                    return;
                  }
                  currentIndex["inStock"].value = value
                    ? Math.floor(value)
                    : "";
                  currentIndex["inStock"].errorMessage = "";
                  setInventoryForm(currentIndex);
                  props.updateInventory({
                    index: index,
                    params: currentIndex,
                  });
                },
                type: props.deviceData.isIPhone ? "number" : "tel",
                disabled: props.disableSellOnlineCustom
              }}
              errClass="err-qty"
              holderClass={`quantity-field no-margin ${props.itemInfo.packagingType == "BOTH"
                ? "half-input"
                : " third-input"
                }`}
              labelAlwaysUp={
                String(formFields["inStock"]?.value).length || false
              }
            /> : null}
            {/* <InputWithMovingLabel
              label={"MRP"}
              key={formFields["mrp"].key}
              errorMessage={formFields["mrp"].errorMessage}
              warning={formFields["mrp"].isWarning}
              prepend={() => <span className={"icon-currency"} />}
              hidePrependBar={true}
              input={{
                value: formFields["mrp"].value,
                onFocus: (e) => {
                  scrollIntoViewHandle(e);
                },
                onChange: (e) => {
                  handleChange(e.currentTarget.value, "mrp", false);
                },
                type: props.deviceData.isIPhone ? "number" : "tel",
              }}
              holderClass={`quantity-field no-margin ${props.itemInfo.packagingType == "BOTH"
                ? "half-input"
                : " third-input"
                }`}
              labelAlwaysUp={String(formFields["mrp"].value).length}
            /> */}
            <div className={`edit-mrp-link ${tabKey!="inventoryCompliance"?"mrp-input-wrap":"first-mrp-input"} `+(props.isInventoryCompliance?'compliance':'') }>
              <InputWithMovingLabel
                label={"MRP"}
                key={formFields["mrp"].key}
                errorMessage={formFields["mrp"].errorMessage}
                warning={formFields["mrp"].isWarning}
                prepend={() => <span className={"icon-currency"} />}
                hidePrependBar={true}
                input={{
                  value: formFields["mrp"].value,
                  onFocus: (e) => scrollIntoViewHandle(e),
                  onChange: (e) => {
                    // showCommentAndUpload(true)
                    handleChange(e.currentTarget.value, "mrp", false);
                  },
                  type: props.deviceData.isIPhone ? "number" : "tel",
                  disabled: disable_mrp_edit
                }}
                holderClass={`quantity-field no-margin ${props.itemInfo.packagingType == "BOTH"
                  ? "half-input"
                  : " third-input"
                  }`}
                labelAlwaysUp={String(formFields["mrp"].value).length}
              />
              {!props.session.isReadOnly && disable_mrp_edit ?
              (<div className={style["bottom-text"]} onClick={e => showMRPModal(true)}>
                <span class="icon-editItem"></span>
                <div className={style["edit-mrp"]}>
                  Edit MRP
                </div>
              </div>
            ) : null}
            </div>





            <InputWithMovingLabel
              label={
                props.itemInfo.packagingType == "BOTH" && unitOfMeasurement
                  ? `Selling Price/${uomJson[unitOfMeasurement]
                    ? uomJson[unitOfMeasurement]["singular"]
                    : unitOfMeasurement
                  }`
                  : "Selling Price"
              }
              key={formFields["selling_price"].key}
              errorMessage={formFields["selling_price"].errorMessage}
              warning={formFields["selling_price"].isWarning}
              prepend={() => <span className={"icon-currency"} />}
              hidePrependBar={true}
              input={{
                value: formFields["selling_price"].value,
                onFocus: (e) => {
                  const currentTarget = e.currentTarget;
                  scrollIntoViewHandle(e);
                  if (currentTarget.value == "") {
                    setTimeout(() => {
                      currentTarget
                        .closest(".sp-field")
                        .classList.add("trunctae-label");
                    }, 100);
                  }
                },
                onBlur: (e) => {
                  if (!props.itemInfo.spPerPc) {
                    const currentTarget = e.currentTarget;
                    if (currentTarget.value == "") {
                      setTimeout(() => {
                        currentTarget
                          .closest(".sp-field")
                          .classList.remove("trunctae-label");
                      }, 100);
                    }
                  }
                },
                onChange: (e) => {
                  handleChange(e.currentTarget.value, "selling_price", false);
                  if(!props.isAddEdit) {
                    getCommissionRate(e.currentTarget.value, props.consignmentNo, props.productId);
                  }
                },
                type: props.deviceData.isIPhone ? "number" : "tel",
                disabled: props.disableSellOnlineCustom
              }}
              holderClass={`sp-field no-margin ${formFields["selling_price"] && formFields["selling_price"].value
                ? "trunctae-label"
                : ""
                } ${props.itemInfo.packagingType == "BOTH"
                  ? "half-input"
                  : " third-input"
                } ${props.isInventoryCompliance?'compliance':''}
                ${props.session.isReadOnly ? 'sp-field-read-only-mode' : ''}
                ` }
              labelAlwaysUp={String(formFields["selling_price"].value).length}
            />
            {props.itemInfo.packagingType == "BOTH" ? (
              <InputWithMovingLabel
                label={
                  unitPerPiece
                    ? "Selling Price/" +
                    (uomJson[unitPerPiece]
                      ? uomJson[unitPerPiece]["singular"]
                      : unitPerPiece)
                    : "Selling Price"
                }
                key={formFields["selling_price"].key}
                errorMessage={formFields["selling_price"].errorMessage}
                warning={formFields["selling_price"].isWarning}
                input={{
                  value: formFields["selling_price"].value,
                  className: "pack-n-loose",
                  onFocus: (e) => {
                    const currentTarget = e.currentTarget;
                    scrollIntoViewHandle(e);
                    if (currentTarget.value == "") {
                      setTimeout(() => {
                        currentTarget
                          .closest(".sp-field")
                          .classList.add("trunctae-label");
                      }, 100);
                    }
                  },
                  onBlur: (e) => {
                    if (!props.itemInfo.spPerPc) {
                      const currentTarget = e.currentTarget;
                      if (currentTarget.value == "") {
                        setTimeout(() => {
                          currentTarget
                            .closest(".sp-field")
                            .classList.remove("trunctae-label");
                        }, 100);
                      }
                    }
                  },
                  onChange: (e) => {
                    handleChange(e.currentTarget.value, "selling_price", false);
                  },
                  type: props.deviceData.isIPhone ? "number" : "tel",
                }}
                holderClass={`sp-field no-margin inp-2 ${formFields["selling_price"] && formFields["selling_price"].value
                  ? "trunctae-label"
                  : ""
                  } half-input`}
                labelAlwaysUp={String(formFields["selling_price"].value).length}
              />
            ) : (
              ""
            )}
          </>
        }
        
        {props.index == 0 && props.itemInfo.lowestPrice && props.itemInfo.lowestPrice < Number(props.inventoryData[0].selling_price.value || 0)?
          <div className="lowest-price-holder" onClick={() => props.matchLowestPrice(props.itemInfo.lowestPrice)}>
            <span className="lowest-price-title"><span className="icon-refresh"></span>Match Lowest Competitor Price: </span><span className="lowest-price-title"><span className={`icon-currency`}></span>{props.itemInfo.lowestPrice}</span>
          </div>
          : null
        }

        { props.isAddEdit || props.isInventoryCompliance || props.session?.viaOmni ? null : <Commission
          toggleCommissionModal = {props.toggleCommissionModal}
          commissionRate={parseFloat(commissionRate).toFixed(2)}
          loading={loading}
          sp={sellingPrice ? sellingPrice : props.sellingPrice}
          productId={props.productId}
          consignmentNo={props.consignmentNo}
          setCommissionModalData={props.setCommissionModalData}
          imageUrl={props.itemInfo.imageUrl}
          productName={props.itemInfo.productName}/>
        }
       
        {getBothCommentAndUpload(formFields)}
      </div>
      {!singleBatch && !props.FromMarketPlaceInv && props.session.viaOmni &&(
        <div
          className={`${style["more-sec-label"]} edit-cost-price`}
          onClick={() => setToggleBatch(true)}
        >
          <i className={`icon-plus ${style["more-sec-icon"]}`}></i>
          <span>View More Details</span>
        </div>
      )}
      {singleBatch && (
        <div style={{ margin: "14px 0px" }}>
          <InputWithMovingLabel
            label="EAN Barcode"
            key={formFields["barcode"].key}
            errorMessage={formFields["barcode"].errorMessage}
            warning={formFields["barcode"].isWarning}
            hidePrependBar={true}
            input={{
              value: formFields["barcode"].value,
              onFocus: (e) => {
                const currentTarget = e.currentTarget;
                scrollIntoViewHandle(e);
                if (currentTarget.value == "") {
                  setTimeout(() => {
                    currentTarget
                      .closest(".sp-field")
                      .classList.add("trunctae-label");
                  }, 100);
                }
              },
              onBlur: (e) => {
                if (!props.itemInfo.spPerPc) {
                  const currentTarget = e.currentTarget;
                  if (currentTarget.value == "") {
                    setTimeout(() => {
                      currentTarget
                        .closest(".sp-field")
                        .classList.remove("trunctae-label");
                    }, 100);
                  }
                }
              },
              onChange: (e) => {
                handleChange(e.currentTarget.value, "barcode", false);
              },
              type: props.deviceData.isIPhone ? "number" : "tel",
            }}
            holderClass={`sp-field no-margin ${formFields["barcode"] && formFields["barcode"].value
              ? "trunctae-label"
              : ""
              } ${props.itemInfo.packagingType == "BOTH"
                ? "half-input"
                : " third-input"
              }`}
            labelAlwaysUp={String(formFields["barcode"].value).length}
          />
          {
            props.session.viaOmni &&
            <InputWithMovingLabel
              input={{
                value: formFields["cost_price"].value,
                onChange: e => {
                  handleChange(e.target.value, "cost_price", false);
                },
                type: 'tel'
              }}
              label={"Cost Price"}
              holderClass={`single-width ${style["inv-cost-price"]}`}
            />
          }
        </div>
      )}
      {props.expiryFlag ?
        <div className={`batch-lot-man-container  marginT15`}>
          <InputWithMovingLabel
            key="newconsignmentNo"
            errorMessage={formFields["consignment_no_display"].errorMessage}
            input={{
              value: formFields["consignment_no_display"].value || "",
              onFocus: (e) => {
                // e.currentTarget && scrollIntoView(e.currentTarget);
              },
              onChange: e => {
                handleChange(e.currentTarget.value, "consignment_no_display", true);
              }
            }}
            label="Batch / Lot Number"
            holderClass={style["batch-lot-num"]}
          />
          <div className={styles['product-expiry-container'] + " " + styles['paddingLR0']}>

            <div className={styles['toggle-container']}>
              <div className={styles['expiryby-label']}>Product Expiry By</div>
              <ToggleBtnGroup
                  selectedValue={expiryBy}
                  onToggle={(e, value) => {
                      toggleExpiryBy(value);
                      // if(props.updateInfoAndErrors){
                      //     props.updateInfoAndErrors('expiryBy',value)
                      // }
                      // below indicate current selected Tab
                      handleChange(value,'expiryBy',true);
                      let formattedDate= (value == 'manufacturing_date'?props.item.manufacturing_date.value:props.item.expiry_date.value) || ""
                      if(formattedDate.split("").length<3){
                        validate("", formattedDate, value);
                        return
                      }        
                      const [yyyy,mm,dd]=formattedDate.split("/").reverse()              
                      validate(
                        new Date(Date.UTC(yyyy,mm-1,dd)),
                        formattedDate,
                        value
                      );
                      // if(value == 'manufacturing_date' && !props.item.manufacturing_date.value && props.item.expiry_date.value) {
                      //     handleChange(props.item.expiry_date.value, 'expiry_date', true);
                      //     validate(getDateObj(props.item.expiry_date), props.item.expiry_date.value, 'expiry_date', "toggle");
                      // } else if(value == 'expiry_date' && props.item.manufacturing_date.value && !props.item.expiry_date.value) {
                      //     handleChange(props.item.manufacturing_date.value, 'manufacturing_date', true);
                      //     validate(getDateObj(props.item.manufacturing_date), props.item.manufacturing_date.value, 'manufacturing_date', "toggle");
                      // }
                      // if(props.item.manufacturing_date.value && props.item.expiry_date.value){
                      //     validate(getDateObj(props.item[value]), props.item[value].value, value, "toggle");
                      // }
                      // if(!props.item.manufacturing_date && !props.item.expiry_date){
                      //     validate('','',value, 'toggle');
                      //     // updateInfoAndErrors(value,props.itemInfo.expiryBy)
                      // }
                  }}
              >
                <ToggleBtnGroup.Btn className={styles['input-grp-btn']} value='manufacturing_date'>
                  Manufacturing Date
                </ToggleBtnGroup.Btn>
                <ToggleBtnGroup.Btn className={styles['input-grp-btn']} value='expiry_date'>
                  Expiry Date
                </ToggleBtnGroup.Btn>
              </ToggleBtnGroup>
            </div>
            <div className={styles['expiry-date-container']}>
              <Form>
                  <FormDate
                      label={expiryBy == 'manufacturing_date' ? 'Manufacturing Date' : 'Expiry Date'}
                      iconClass='icon-calendarNew'
                      onDateChange={(event, obj, formattedDate) => {
                          if(formattedDate){
                              if(expiryBy == 'manufacturing_date' ) {
                                  handleChange(formattedDate, 'manufacturing_date', true);
                              } else {
                                  handleChange(formattedDate, 'expiry_date', true);
                              }
                          }else{
                              handleChange(formattedDate, 'manufacturing_date', true);
                              handleChange(formattedDate, 'expiry_date', true);
                          }
                          // handleChange('isApplicableExpDate', true, true);
                          validate(obj, formattedDate, expiryBy);
                      }}
                      dateformat='dd/mm/yyyy'
                      errorMessage={formFields[expiryBy].errorMessage}
                      isMobile={props.deviceData.isMobile}
                      onBlur={(event,obj,date,isValid)=>{ if(!isValid && props.deviceData.isMobile) updateInfoAndErrors(expiryBy, null, "Please Enter Valid Date", null, null)}}
                      variant='withMovingLabel'
                      warning={formFields[expiryBy].isWarning || (!!formFields[expiryBy].errorMessage && props.session.viaOmni)}
                      startDate={getDateObj(formFields[expiryBy])}
                      cusPortalId={{
                        id:"root-portal",
                        zIndex:15000,
                      }}
                  ></FormDate>
              </Form>
            </div>
            {expiryBy == 'expiry_date' ? null :
              <div className={styles['best-before-container']}>
                <InputWithMovingLabel
                  value={formFields['best_before'].value}
                  // ref={bestBeforeRef}
                  label='Best Before'
                  holderClass={styles['best-before-input']}
                  errorMessage={formFields['best_before'].errorMessage}
                  input={{
                    value: formFields['best_before'].value || '',
                    onFocus: (e) => {
                      // e.currentTarget && scrollIntoView(e.currentTarget,'add-edit-product');
                    },
                    onChange: e => { handleChange(e.currentTarget.value, 'best_before', true) },
                    onBlur: e => {
                      if (!e.currentTarget.value) {
                        // if(formFields['manufacturing_date'].value)
                        // updateInfoAndErrors('best_before',null,"Please Enter Best Before",null);
                      } else {
                        validateBestBeforeDate();
                      }
                    },
                    type: props.deviceData.isIPhone ? 'number' : 'tel'
                  }}
                />
                <Dropdown
                  className={`${styles['dropdown-div']} ${props.deviceData.isMobile ? styles['dropdown-div-mobile'] : ''}`}
                  optionList={dateOptions}
                  onChange={(e, value) => {
                    handleChange(e.key, 'best_before_unit', true);
                    if (formFields['best_before'])
                      validateBestBeforeDate({ unit: e.key });
                  }}
                  placeholder='Select Period'
                  label='Select Period'
                  value={formFields['best_before_unit'].value || 'months'}
                  scrollBarProps={{
                    autoHide: false
                  }}
                  openTop={props.openTop}
                ></Dropdown>
              </div>
            }
          </div>
        </div>
        : null
      }
      {getUpdateMRPModal()}
    </>
  );
};

const mapStateToProps = (state, props) => {
  // const inventoryData = { ...state.inventory.inventoryList };
  // const item = inventoryData[props.index]
  //   ? JSON.parse(JSON.stringify(inventoryData[props.index]))
  //   : {};

  let expiryFlag=props.expiryFlag
  if(state.session.viaOmni){
    expiryFlag=state.permissions?.packagePermissionData?.isMaintainExpiry
  }
  return {
    deviceData: state.deviceData,
    uomArr: state.uom,
    errors: state.items.errors,
    permissions: state.permissions,
    displayInfo: state.items.displayInfo,
    session:state.session,
    expiryFlag,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateInventory: (payload) => dispatch(updateInventory(payload)),
    showHideLoader: (payload) => dispatch(showHideLoader(payload)),
  };
};

export default connect(mapStateToProps)(memo(SingleBatch));
